import {
  useCurrentProductId,
  useProjectEntitlements,
} from '@adsk/alloy-provider';
import { TRACK_EVENTS } from '@adsk/acs-admin-ui-components-helpers';
import { useAnalytics } from '@adsk/acs-admin-ui-components-hooks';

const useSendAnalytics = ({
  memberId,
  selectedAccessLevel,
  selectedCompany,
  selectedRole,
}) => {
  const { trackEvent } = useAnalytics();
  const { currentProject } = useProjectEntitlements();
  const currentProductId = useCurrentProductId();

  const sendAnalytics = (type, product) => {
    trackEvent(
      `${TRACK_EVENTS.SCOPE.PROJECT_ADMIN}.${TRACK_EVENTS.SOURCE.MEMBER_PROFILE}.${type}`,
      {
        product_id: currentProductId,
        access_level: selectedAccessLevel.value,
        product,
        company: !!selectedCompany,
        role: !!selectedRole,
        selected_user_id: memberId,
        account_admin: currentProject?.accessLevels?.accountAdministrator,
        project_admin: currentProject?.accessLevels?.projectAdministrator,
      }
    );
  };

  return sendAnalytics;
};

export default useSendAnalytics;
